import server from "src/api/server";
import dynamic from "next/dynamic";

import Seo from "src/components/shared/Seo";
import { useRouter } from "next/router";
const HomePage = dynamic(() => import("src/modules/HomePage/HomePage"));

export default function Home({
  data,
  appSetting = {},
  metaData,
  footerSettings,
}) {
  const router = useRouter();
  const { locale } = router;

  const customMeta = [
    { name: "title", content: metaData?.[0]?.name?.[locale] },
    {
      name: "description",
      content: metaData?.[0]?.content?.[locale],
    },
  ];

  return (
    <>
      <Seo
        metaData={customMeta}
        appSetting={{
          ...appSetting,
          ...footerSettings,
        }}
        pageUrl={
          typeof window !== "undefined"
            ? window.location.href
            : `${process.env.NEXT_PUBLIC_SITE_URL}/${router.asPath}`
        }
      />
      <HomePage
        data={data}
        appSetting={appSetting}
        footerSettings={footerSettings}
      />
    </>
  );
}

export async function getStaticProps() {
  try {
    // Parallel fetching for better performance
    const [
      indexRes,
      partnerRes,
      galleryRes,
      bannerRes,
      benfitHeaderRes,
      benfitPostsRes,
      splitersRes,
      pricesRes,
      questionsRes,
      metaRes,
      testmonialsRes,
      sliderRes,
      footerRes,
      profilePostRes,
      certificationsRes,
    ] = await Promise.all([
      server.get("/api/index"),
      server.get("/api/posts/partners/all"),
      server.get("/api/posts/our_works/all"),
      server.get("/api/posts/banners/all"),
      server.get("/api/posts/benfits_page/all"),
      server.get("/api/posts/benfits_media/all"),
      server.get("/api/posts/homepage_spliter/all"),
      server.get("/api/posts/prices_list/all"),
      server.get("/api/posts/questions_home/all"),
      server.get("/api/metadataTags?type=home"),
      server.get("/api/posts/opinions/all"),
      server.get("/api/posts/sliders/all"),
      server.get("/api/footer"),
      server.get("/api/posts/656"),
      server.get("/api/posts/672"),
    ]);

    const indexData = indexRes?.data?.data;
    const appSetting = indexData?.AppSetting;

    return {
      props: {
        data: {
          indexData: indexData || null,
          partnerData: partnerRes?.data?.data || null,
          galleryData: galleryRes?.data?.data || null,
          bannerData: bannerRes?.data?.data || null,
          benfitDataPosts: benfitPostsRes?.data?.data || null,
          benfitDataHeader: benfitHeaderRes?.data?.data || null,
          splitersData: splitersRes?.data?.data || null,
          pricesData: pricesRes?.data?.data || null,
          testmonialsData: testmonialsRes?.data?.data || null,
          sliderData: sliderRes?.data?.data || null,
          questions: questionsRes?.data?.data || null,
          profilePost: profilePostRes?.data?.data || null,
          certificationsPost: certificationsRes?.data?.data || null,
        },
        metaData: metaRes?.data?.data?.metadata_tags || null,
        appSetting: appSetting || null,
        footerSettings: footerRes?.data?.data || null,
      },
      revalidate: 60,
    };
  } catch (error) {
    console.error("Error fetching home page data:", error);
    return {
      props: {
        data: {
          indexData: null,
          partnerData: null,
          galleryData: null,
          bannerData: null,
          benfitDataPosts: null,
          benfitDataHeader: null,
          splitersData: null,
          pricesData: null,
          testmonialsData: null,
          sliderData: null,
          questions: null,
          profilePost: null,
          certificationsPost: null,
        },
        metaData: null,
        appSetting: null,
        footerSettings: null,
      },
      revalidate: 60,
    };
  }
}
